<div class="l-core-contents__inner">
  <div class="l-core-contents__main">
    <div class="l-section">
      <div id="goshokainet-login-form-area" class="p-terms-conditions">
        <!-- 上の一つインプット -->
        <div
          class="p-booking-info-mdl__row p-booking-info-mdl__row--03 p-booking-info-mdl__row--mb16"
          [formGroup]="inputFG"
        >
          <div class="p-payment-method-finance__item-block-box--select">
            <h2 class="p-booking-info-mdl__row--mb16" [innerHTML]="'label.introduceInfomation' | staticMsg"></h2>
            <!-- ご紹介のインプット -->
            <div
              class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325"
              style="width: 100%"
            >
              <asw-input
                required
                label="{{ 'label.introduce.introduceNumber' | staticMsg }}"
                placeholder="{{ 'placeholder.introduceNumber' | staticMsg }}"
                formControlName="inputFC"
                maxlength="9"
              >
              </asw-input>
            </div>
          </div>
        </div>

        <!-- 下の二つインプット -->
        <div class="p-booking-info-mdl__row--mt16" [formGroup]="inputFG_2">
          <h3 class="p-booking-info-mdl__row--mb16" [innerHTML]="'label.introduce.name' | staticMsg"></h3>
          <!-- 日本サイト以外　不要の認識
            <h3 class="p-booking-info-mdl__row--mb16" [innerHTML]="'label.introduce.name.withNoFormat' | staticMsg"></h3>
          -->
          <div class="p-booking-info-mdl__row p-booking-info-mdl__row--03 p-booking-info-mdl__row--mb16">
            <!-- 性のインプット -->
            <div
              class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325"
              style="width: 100%"
            >
              <div class="p-booking-info-mdl__row-item">
                <asw-input
                  required
                  label="{{ 'label.firstName' | staticMsg }}"
                  placeholder="{{ 'placeholder.introducerFirstName' | staticMsg }}"
                  formControlName="firstName"
                  maxlength="15"
                >
                </asw-input>
              </div>
            </div>
            <!-- 名のインプット -->
            <div class="p-booking-info-mdl__row-item">
              <div
                class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325"
                style="width: 100%"
              >
                <asw-input
                  required
                  label="{{ 'label.lastName' | staticMsg }}"
                  placeholder="{{ 'placeholder.introducerLastName' | staticMsg }}"
                  formControlName="lastName"
                  maxlength="15"
                >
                </asw-input>
              </div>
            </div>
          </div>
          <!-- ボタン -->
          <div class="c-flight-plan__item-5 p-booking-info-mdl__row--mt16">
            <asw-button
              id="goshokai-net-login-pres-submit-button1"
              (click$)="onClickEvent()"
              [label]="'label.toSearchRoundTripbutton' | staticMsg"
              throttleClick
            ></asw-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
